import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { mapStateToProps, mapDispatchToProps } from '../../Store';
import rightArrow from '../../assets/images/arrow_right_solid.svg';
import { Card, Row, Col } from 'react-bootstrap';
import { getConfigForComponent, TeleScript, BoxedContent } from 'sg-ui-components';

export class ActiveSweepstakes extends React.Component {
    constructor(props) {
        super(props);
        this.state = { showAll: false };
    }

    render() {
        //* Component setup
        const title = this.props.title ?? 'Active Promotions';
        const button_vap = this.props.buttons === 'view-all-promotions';
        const promotionsActiveSweepstakes = getConfigForComponent('promotionsActiveSweepstakes', this.props.config);
        const mode = promotionsActiveSweepstakes?.mode ?? 'show-all';
        const displayCount = promotionsActiveSweepstakes?.options?.limit ?? 3;
        const telescript = promotionsActiveSweepstakes?.telescript;
        const { showAll } = this.state;

        //* Validation check
        const valid = this.props.sweep?.sweeps && Array.isArray(this.props.sweep.sweeps) && this.props.sweep.sweeps.length;
        if (!valid) return null;

        const activeSweeps = this.props.sweep.sweeps
            .filter((sweep) => sweep.category === 'current')
            .sort((a, b) => {
                return a.rank - b.rank;
            });
        const sweepsToShow = mode === 'show-limited' && !showAll ? activeSweeps.slice(0, displayCount) : activeSweeps;

        return (
            <>
                <BoxedContent hasCollapser={false} variant='theme-purple' title={title} isActive={true} note='Active Promotions' hash='active-promotions'>
                    <Row>
                        {sweepsToShow.map(({ id, name, extra }) => {
                            const description = extra?.short_description || extra?.description;
                            let trimDesc = description;
                            if (trimDesc) {
                                const maxLength = 500;
                                const originalString = trimDesc;
                                const newRegex = /(<([^>]+)>)/gi;
                                let tags = originalString.match(newRegex);
                                let truncatedString = originalString.replace(/(<([^>]+)>)/gi, '<>').trimEnd();

                                if (truncatedString.length >= maxLength) {
                                    truncatedString = truncatedString.substring(0, maxLength);
                                    const lastSpace = truncatedString.lastIndexOf(' ');
                                    truncatedString = truncatedString.substring(0, lastSpace).trim() + ' ...';
                                }

                                if (tags) {
                                    tags.forEach((element) => {
                                        truncatedString = truncatedString.replace('<>', element);
                                    });
                                }

                                trimDesc = truncatedString;
                            }
                            return id && name && extra && extra.image && description ? (
                                <Col lg={4} className='my-3' key={id}>
                                    <Card className='sweepstake-item'>
                                        <Card.Img alt={`${name} promotional image`} variant='top' src={extra.image} className='cover-image' />
                                        <Card.Body>
                                            <Card.Title>{name}</Card.Title>
                                            <Card.Text>
                                                <div dangerouslySetInnerHTML={{ __html: trimDesc }}></div>
                                            </Card.Text>
                                            <div className='d-flex justify-content-end'>
                                                <a href={`promotion?id=${id}`} className='more-info-link'>
                                                    More Info <img alt='' src={rightArrow} className='svg-icon' />
                                                </a>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ) : null;
                        })}
                    </Row>

                    {button_vap ? (
                        <div className='text-center my-4'>
                            <Link to='/promotions' className='btn theme-btn theme-outline'>
                                <TeleScript line={telescript?.view_all_promotions}>View all Promotions</TeleScript>
                            </Link>
                        </div>
                    ) : null}

                    {mode === 'show-limited' && !showAll && !button_vap && activeSweeps?.length > displayCount && (
                        <div className='show-more-section text-center'>
                            <button
                                type='button'
                                className='btn theme-btn theme-outline'
                                onClick={() => {
                                    this.setState({ showAll: true });
                                }}>
                                <TeleScript line={telescript?.view_more}>View more</TeleScript>
                            </button>
                        </div>
                    )}
                </BoxedContent>
            </>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ActiveSweepstakes);
